// Shown when no route matches — including an unknown tenant segment
// (e.g. /unknown). We deliberately do NOT silently fall back to the default
// chatbot; instead we offer a clear link to the site root.
export function NotFound() {
  return (
    <div className="flex flex-col h-screen items-center justify-center gap-6 px-6 text-center">
      <div>
        <h1 className="text-5xl font-bold text-primary-600">404</h1>
        <p className="mt-3 text-lg text-foreground">
          Diese Seite wurde nicht gefunden.
        </p>
      </div>
      {/* Plain anchor to the absolute site root so it escapes any tenant basepath. */}
      <a
        href="/"
        className="px-6 py-3 rounded-xl font-medium bg-primary-600 text-white shadow-lg hover:bg-primary-700 transition-colors"
      >
        Zur Startseite
      </a>
    </div>
  );
}
